var base = require('settings/payment-method/update-vat-id');

Vue.component('spark-update-vat-id', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method/update-vat-id.js